import sending from './Sending'
import done from './Done'
import sendingDecember from './SendingDecember'
import nothing from './Nothing'
import parking from './Parking'
import parkingRed from './ParkingRed'
import passportTravel from './PassportTravel'
import happyBirthday from './HappyBirthday'
import calendar from './Calendar'
import emptyParkSlot from './EmptyParkSlot'
import message from './Message'
import noFiles from './NoFiles'
import files from './Files'
import build from './Build'
import robot404 from './Robot404'
import update from './Update'
import userWarning from './UserWarning'
import Panel from './Panel'
import MoneyTransaction from './MoneyTransaction'
import CommonLottie from './CommonLottie'
import PendingPayment from './PendingPayment'
import Budget from './Budget'
import * as CalendarDate from './assets/calendar-date.json'
import * as ContactUs from './assets/contact-us.json'
import * as DeleteUser from './assets/delete-user.json'
import * as RelacionesPublicas from './assets/relaciones-publicas.json'
import * as ScheduleAppointment from './assets/schedule-appointment.json'
import * as SocialMedia from './assets/social-media.json'
import * as TimeManagement from './assets/time-management.json'
import * as Email from './assets/Email.json'
import * as SearchNotFound from './assets/search-not-found.json'

export const Sending = sending
export const Done = done
export const SendingDecember = sendingDecember
export const Nothing = nothing
export const Parking = parking
export const ParkingRed = parkingRed
export const PassportTravel = passportTravel
export const HappyBirthday = happyBirthday
export const Calendar = calendar
export const EmptyParkSlot = emptyParkSlot
export const Message = message
export const NoFiles = noFiles
export const Files = files
export const Build = build
export const Robot404 = robot404
export const Update = update
export const UserWarning = userWarning
export { Panel, MoneyTransaction, CommonLottie, PendingPayment, Budget ,CalendarDate, ContactUs, DeleteUser,RelacionesPublicas,ScheduleAppointment,SocialMedia,
        TimeManagement, Email,SearchNotFound }